<div class="card dialog-box">
  <div class="card-header">
    WARNING

    <span class="float-end" (click)="ignoreLicenseCheck()"
      ><i class="fa-solid fa-xmark"></i
    ></span>
  </div>
  <div>
    <div class="alert alert-danger">
      You may not have the required credentials (e.g. Security Licence) for
      {{ credentialState | uppercase }}.

      <div class="mt-2">
        Credentials can be added on your
        <a
          (click)="ignoreLicenseCheck(true)"
          class="link-primary cursor-pointer"
        >
          Company Profile
        </a>
        page.
      </div>
    </div>

    <div class="form-check">
      <input
        class="form-check-input"
        type="checkbox"
        id="licenseCheckbox"
        (change)="licenseReminderField = !licenseReminderField"
      />
      <label class="form-check-label" for="licenseCheckbox">
        Don't show this again
      </label>
    </div>

    <div class="row row-cols-2 mt-4">
      <div class="col">
        <button
          class="btn btn-secondary btn-lg w-100"
          (click)="ignoreLicenseCheck()"
        >
          Ignore
        </button>
      </div>
      <div class="col">
        <button
          class="btn btn-primary btn-lg w-100"
          (click)="showLicensePopup()"
        >
          Add Credentials Now
        </button>
      </div>
    </div>
  </div>
</div>
